import type { SubmissionResult } from "@conform-to/react";
import { type Fields, getGlobals } from "./get-globals";

function getFieldErrors<FormError = Array<string>>(fields: Fields) {
  return (
    fields?.reduce(
      (fieldErrors, { field, errors }) => {
        if (!errors?.length) return fieldErrors;

        const messsages = errors.map(({ message }) => message);

        Object.assign(fieldErrors, { [field ?? ""]: messsages });

        return fieldErrors;
      },
      {} as Record<string, FormError | null>,
    ) ?? ({} as Record<string, FormError | null>)
  );
}

function getFieldInitialValues(fields: Fields | undefined | null) {
  return (
    fields?.reduce(
      (acc, { field, value }) => {
        if (!field || value === undefined || value === null) return acc;

        if (acc) {
          Object.assign(acc, { [field]: value });
          return acc;
        }

        return { [field]: value };
      },
      {} as SubmissionResult["initialValue"],
    ) ?? {}
  );
}

export function getSubmissionResult(): SubmissionResult | null {
  const { fields, errors } = getGlobals() || {};
  if (!fields && !errors) return null;

  const allErrors = {
    ...(errors ? { "": errors.map(({ message }) => message) } : {}),
    ...getFieldErrors(fields),
  };

  return {
    status: fields?.some((field) => field.errors?.length) ? "error" : "success",
    error: allErrors,
    initialValue: getFieldInitialValues(fields),
  };
}
